<template>
  <!--  <div v-if="isBislet === true">
      <div class="buttons-wrapper">
        <div class="buttons-inner-wrapper">
          <div class="category-buttons text-body06-regular">
            <b-button
                v-for="button in groupedCategory"
                class="input-button"
                :class="{activeButton: selectedGroupedCategory.includes(button.id)}"
                @click="updateGroupedCategory(button.id)">{{ button.description }}
            </b-button>
          </div>
        </div>
      </div>
      <div class="inputmask" :style="isBislet ? { backgroundColor: '#CEE4FF',paddingTop:'20px' } : { backgroundColor: 'white' }">


        <div class="mulitple-inputs">

          <div class="mulitple-inputs-location">
            <location-control-version2
                :bookViewFilter=false
                v-bind:value="pickUpLocationId"
                v-bind:locations="locations"
                v-bind:active="selectPickUpLocation"
                v-bind:label="pickUpLocationLabel"
                @update-location="updatePickupLocation"
            ></location-control-version2>
          </div>
          &lt;!&ndash; Map control of pick up location &ndash;&gt;
          <div class="row" v-if="false">
            <div class="col-lg-12">
              <location-details v-bind:location="pickupLocation"></location-details>
            </div>
            <div class="col-lg-12" v-if="false">
              <location-map ref="map" v-bind:locations="locations" :selectedLocation="pickupLocation"></location-map>
            </div>
          </div>

          <div class="mulitple-inputs-datetime">

            <date-time-input-separated
                :datelabel="pickUpDateLabel"
                :timelabel="pickUpTimeLabel"
                :widgetType='0'
                :bookViewFilter=false
                :minDate="minDate"
                :location="pickupLocation"
                id="pickUpDateTimeInput"
                v-model="pickUpDateTime"
                v-on:click="beginSelectPickUpDateTime()"
                v-on:focus="beginSelectPickUpDateTime()"
                @update-date="updatePickupDateTime"
            ></date-time-input-separated>
          </div>


        </div>

        <div class="mulitple-inputs">


          <div class="mulitple-inputs-location">
            <location-control-version2
                :bookViewFilter=false
                v-bind:value="returnLocationId"
                v-bind:locations="locations"
                v-bind:active="selectReturnLocation"
                v-bind:label="returnLocationLabel"
                @update-location="updateReturnLocation"
            ></location-control-version2>
          </div>
          &lt;!&ndash; Map control of return location &ndash;&gt;
          <div class="row" v-if="false">
            <div class="col-lg-12">
              <location-details v-bind:location="returnLocation"></location-details>
            </div>
            <div class="col-lg-12" v-if="false">
              <location-map ref="map" v-bind:locations="locations" :selectedLocation="returnLocation"></location-map>
            </div>
          </div>
          <div class="mulitple-inputs-datetime">
            <date-time-input-separated
                :widgetType='1'
                :bookViewFilter=false
                :datelabel="returnDateLabel"
                :timelabel="returnTimeLabel"
                :minDate="pickUpDateTime"
                :location="returnLocation"
                id="returnDateTimeInput"
                v-model="returnDateTime"
                v-on:click="beginSelectReturnDateTime()"
                v-on:focus="beginSelectReturnDateTime()"
                @update-date="updateReturnDateTime"
            ></date-time-input-separated>
          </div>

        </div>

        <div class="form-group">
          <div style="text-align:right;" v-if="false">
                      <span class="glyphicon">
                          <i id="help" class='fa fa-question-circle fa-2x' v-on:click="help()"></i>
                      </span>
          </div>

          <div v-html="quoteFetchErrorText"></div>
          <button
              class="option-footer-button text-body01-bold"
              v-on:click.prevent="fetchQuotes()"
              :disabled="!canFetchQuotes"
          >
            {{ $t('message.showCars') }}
          </button>
        </div>

      </div>
    </div>-->
<div>
  <div v-show="desktopVersion">

    <div class="inputmask" :style="isBislet ? { backgroundColor: '#CEE4FF' } : { backgroundColor: 'white' }">
      <div class="buttons-contrainer-wrapper buttonGroupBackgroundColor">
        <div class="category-buttons text-body06-regular ">
          <b-button
              v-for="button in groupedCategory"
              class="input-button-bislet"
              :class="{activeButton: selectedGroupedCategory.includes(button.id)}"
              @click="updateGroupedCategory(button.id)">{{ button.description }}
          </b-button>
        </div>
      </div>
      <div class="mulitple-inputs">

        <div class="mulitple-inputs-location">
          <location-control-version2
              :bookViewFilter=false
              v-bind:value="pickUpLocationId"
              v-bind:locations="locations"
              v-bind:active="selectPickUpLocation"
              v-bind:label="pickUpLocationLabel"
              @update-location="updatePickupLocation"
          ></location-control-version2>
        </div>
        <!-- Map control of pick up location -->
        <div class="row" v-if="false">
          <div class="col-lg-12">
            <location-details v-bind:location="pickupLocation"></location-details>
          </div>
          <div class="col-lg-12" v-if="false">
            <location-map ref="map" v-bind:locations="locations" :selectedLocation="pickupLocation"></location-map>
          </div>
        </div>

        <div class="mulitple-inputs-location">
          <location-control-version2
              :bookViewFilter=false
              v-bind:value="returnLocationId"
              v-bind:locations="locations"
              v-bind:active="selectReturnLocation"
              v-bind:label="returnLocationLabel"
              @update-location="updateReturnLocation"
          ></location-control-version2>
        </div>
        <!-- Map control of return location -->
        <div class="row" v-if="false">
          <div class="col-lg-12">
            <location-details v-bind:location="returnLocation"></location-details>
          </div>
          <div class="col-lg-12" v-if="false">
            <location-map ref="map" v-bind:locations="locations" :selectedLocation="returnLocation"></location-map>
          </div>
        </div>


      </div>

      <div class="mulitple-inputs">

        <div class="mulitple-inputs-datetime">

          <date-time-input-separated
              :datelabel="pickUpDateLabel"
              :timelabel="pickUpTimeLabel"
              :widgetType='0'
              :bookViewFilter=false
              :minDate="minDate"
              :location="pickupLocation"
              id="pickUpDateTimeInput"
              v-model="pickUpDateTime"
              v-on:click="beginSelectPickUpDateTime()"
              v-on:focus="beginSelectPickUpDateTime()"
              @update-date="updatePickupDateTime"
          ></date-time-input-separated>
        </div>

        <div class="mulitple-inputs-datetime">
          <date-time-input-separated
              :widgetType='1'
              :bookViewFilter=false
              :datelabel="returnDateLabel"
              :timelabel="returnTimeLabel"
              :minDate="pickUpDateTime"
              :location="returnLocation"
              id="returnDateTimeInput"
              v-model="returnDateTime"
              v-on:click="beginSelectReturnDateTime()"
              v-on:focus="beginSelectReturnDateTime()"
              @update-date="updateReturnDateTime"
          ></date-time-input-separated>
        </div>

      </div>

      <div class="form-group">
        <div style="text-align:right;" v-if="false">
                    <span class="glyphicon">
                        <i id="help" class='fa fa-question-circle fa-2x' v-on:click="help()"></i>
                    </span>
        </div>

        <div v-html="quoteFetchErrorText"></div>
        <button
            class="option-footer-button text-body01-bold"
            v-on:click.prevent="fetchQuotes()"
            :disabled="!canFetchQuotes"
        >
          {{ $t('message.showCars') }}
        </button>
      </div>

    </div>
  </div>
  <div v-show="tabletVersion || mobileVersion">

    <div class="inputmask" :style="isBislet ? { backgroundColor: '#CEE4FF' } : { backgroundColor: 'white' }">
      <div class="buttons-contrainer-wrapper buttonGroupBackgroundColor">
        <div class="category-buttons text-body06-regular ">
          <b-button
              v-for="button in groupedCategory"
              class="input-button-bislet"
              :class="{activeButton: selectedGroupedCategory.includes(button.id)}"
              @click="updateGroupedCategory(button.id)">{{ button.description }}
          </b-button>
        </div>
      </div>
      <div class="mulitple-inputs mobile-version-multiple-inputs">

        <div class="mulitple-inputs-location">
          <location-control-version2
              :bookViewFilter=false
              v-bind:value="pickUpLocationId"
              v-bind:locations="locations"
              v-bind:active="selectPickUpLocation"
              v-bind:label="pickUpLocationLabel"
              @update-location="updatePickupLocation"
          ></location-control-version2>
        </div>
        <!-- Map control of pick up location -->
        <div class="row" v-if="false">
          <div class="col-lg-12">
            <location-details v-bind:location="pickupLocation"></location-details>
          </div>
          <div class="col-lg-12" v-if="false">
            <location-map ref="map" v-bind:locations="locations" :selectedLocation="pickupLocation"></location-map>
          </div>
        </div>

        <div class="mulitple-inputs-datetime">

          <date-time-input-separated
              :datelabel="pickUpDateLabel"
              :timelabel="pickUpTimeLabel"
              :widgetType='0'
              :bookViewFilter=false
              :minDate="minDate"
              :location="pickupLocation"
              id="pickUpDateTimeInput"
              v-model="pickUpDateTime"
              v-on:click="beginSelectPickUpDateTime()"
              v-on:focus="beginSelectPickUpDateTime()"
              @update-date="updatePickupDateTime"
          ></date-time-input-separated>
        </div>

      </div>

      <div class="mulitple-inputs mobile-version-multiple-inputs">
        <div class="mulitple-inputs-location">
          <location-control-version2
              :bookViewFilter=false
              v-bind:value="returnLocationId"
              v-bind:locations="locations"
              v-bind:active="selectReturnLocation"
              v-bind:label="returnLocationLabel"
              @update-location="updateReturnLocation"
          ></location-control-version2>
        </div>
        <!-- Map control of return location -->
        <div class="row" v-if="false">
          <div class="col-lg-12">
            <location-details v-bind:location="returnLocation"></location-details>
          </div>
          <div class="col-lg-12" v-if="false">
            <location-map ref="map" v-bind:locations="locations" :selectedLocation="returnLocation"></location-map>
          </div>
        </div>

        <div class="mulitple-inputs-datetime">
          <date-time-input-separated
              :widgetType='1'
              :bookViewFilter=false
              :datelabel="returnDateLabel"
              :timelabel="returnTimeLabel"
              :minDate="pickUpDateTime"
              :location="returnLocation"
              id="returnDateTimeInput"
              v-model="returnDateTime"
              v-on:click="beginSelectReturnDateTime()"
              v-on:focus="beginSelectReturnDateTime()"
              @update-date="updateReturnDateTime"
          ></date-time-input-separated>
        </div>

      </div>

      <div class="form-group">
        <div style="text-align:right;" v-if="false">
                    <span class="glyphicon">
                        <i id="help" class='fa fa-question-circle fa-2x' v-on:click="help()"></i>
                    </span>
        </div>

        <div v-html="quoteFetchErrorText"></div>
        <button
            class="option-footer-button text-body01-bold"
            v-on:click.prevent="fetchQuotes()"
            :disabled="!canFetchQuotes"
        >
          {{ $t('message.showCars') }}
        </button>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import moment from "moment";
import "moment-timezone";
import LocationDetails from "../components/LocationDetails";
import LocationMap from "../components/LocationMap";
import DateTimeInput from "../components/DateTimeInputNative";
import {PickUpReturnStates} from "../services/pickupReturnStates";
import {mapActions, mapGetters} from "vuex";
import LocationList from '../components/LocationList.vue';
import LocationControl from '../components/LocationControl.vue';
import GroupedCategoryControl from '../components/GroupedCategoryControl.vue'
import VueI18n from 'vue-i18n';
import Axios from "axios";
import dayjs from 'dayjs/esm/index.js'

import DateTimeInputSeparated from "../components/DateTimeInputNativeSeparated.vue";

import LocationControlVersion2 from '../components/LocationControl2.vue';

export default {
  name: "Book",
  data() {
    return {
      windowWidth: 0,
      isBislet: process.env.VUE_APP_CUSTOMERNAME === "Bislet Bilutleie",
      minDate: "",
      min2Date: "",
      showMap: false,
      oneway: false,
      isHidden: true,
      locationSelected: 1,
      // Pick UP Location
      selectPickUpLocation: false,
      pickUpLocationId: 0,
      pickupLocation: {
        name: "My Location",
        address: "",
        zipAndCity: "",
        openingHours: "",
        latLion: {lat: 0.0, lon: 0.0},
        id: 0,
      },
      pickUpLocationLabel: this.$t('message.pickUpLocation'),//'Pick-Up Location',
      pickUpLocationText: "",
      // Pick UP Date
      selectPickUpDateTime: null,
      pickUpDateTime: "",
      pickUpTimeLabel: this.$t('message.pickUpTime'),//"Pick-Up time",
      pickUpDateLabel: this.$t('message.pickUpDate'),//"Pick-Up date",
      // Return Location
      selectReturnLocation: false,
      returnLocationId: 0,
      returnLocation: {
        name: "My Location",
        address: "",
        zipAndCity: "",
        openingHours: "",
        latLion: {lat: 0.0, lon: 0.0},
        id: 0,
      },
      returnLocationLabel: this.$t('message.returnLocation'),//"Return location",
      returnLocationText: "",
      // Return Date
      pickUpReturnState: PickUpReturnStates.INITIAL,
      selectReturnDateTime: null,
      returnDateTime: "",
      returnDateLabel: this.$t('message.returnDate'),
      returnTimeLabel: this.$t('message.returnTime'),//"Return time",
      showFilter: false,
      filterPrice: 0,
      quoteFetchErrorText: "",
      bgPath: process.env.VUE_APP_BG_PATH,

      // GroupedCategories
      groupedCategory: [],
      selectedGroupedCategoryID: null,
      selectedGroupedCategory: [],
    };
  },

  async created() {
    this.showLoader();
    try {
      await this.getLocations();
      this.groupedCategory = await this.getGroupedCategories()

      // preselect active groupedCategorys
      for (let item of this.groupedCategory) {
        console.log("created - groupedCategory ", item.active);
        if (item.active === 1) {
          this.updateGroupedCategory(item.id);
        }
      }

      this.hideLoader();

    } catch (error) {
      this.quoteFetchErrorText = error;
      this.hideLoader();
    }
  },
  async mounted() {

    const today = dayjs().set('hour', 12).set('minute', 0).set('second', 0);
    // tommorrow
    const date2 = today.add(24, 'hour');
    // day after tommorrow
    const date3 = date2.add(24, 'hour');

    var today2 = new Date();
    this.minDate = today2;
    this.pickUpDateTime = date2.toDate();
    this.returnDateTime = date3.toDate();

    // check if it is in iframe
    if (window.self !== window.top) {
      document.body.classList.add('selectionPage');
    }else{
      document.body.classList.remove('selectionPage');
    }


    this.windowWidth = window.innerWidth;

    // EventHanler to get resizing of the Window to set datepicker sideBySide to true or false
    const resizeObserver = new ResizeObserver(() => {
      setTimeout(() => {
        if(this.windowWidth !== window.innerWidth){
          this.windowWidth = window.innerWidth;
        }
      }, 100);

    });
    resizeObserver.observe(document.body);
    },
  destroyed(){
    console.log("%%%%%%% unmounted")
    document.body.classList.remove('selectionPage');
  },
  methods: {
    ...mapActions(["getLocations"]),
    showLoader() {
      this.$bus.$emit("showLoader");
    },
    hideLoader() {
      this.$bus.$emit("hideLoader");
    },

    /**
     * get the groupedCategories, which are used for a dropdown list for a category
     * preselection in the Quotes component
     */
    getGroupedCategories: async function () {
      try {
        const result = await Axios.get(`groupedcategory`);
        if (result.status != "200") throw new Error(result);
        return result.data;
      } catch (err) {
        console.error(err);
        return [];
      }
    },


    updatePickupLocation(location) {

      this.pickUpLocationId = location;
      this.selectPickUpLocation = true;
      this.isHidden = true;

      const loc = this.locations.filter((x) => x.id == location)[0];
      if (loc) {
        this.pickupLocation = loc;
      } else {
        this.pickupLocation = {
          name: "My Location",
          address: "",
          zipAndCity: "",
          openingHours: "",
          latLion: {lat: 0.0, lon: 0.0},
          id: 0,
        };

      }

      this.updateReturnLocation(location);

    },
    updateReturnLocation(location) {
      this.returnLocationId = location;
      this.selectReturnLocation = true;
      this.isHidden = true;

      const loc = this.locations.filter((x) => x.id == location)[0];
      if (loc) {
        this.returnLocation = loc;
      } else {
        this.returnLocation = {
          name: "My Location",
          address: "",
          zipAndCity: "",
          openingHours: "",
          latLion: {lat: 0.0, lon: 0.0},
          id: 0,
        };
      }

      //console.log("ReturnLocation updated! ", location);
    },
    updatePickupDateTime(newValue) {
      if ((dayjs(newValue).format('YYYY-MM-DD')) === (dayjs(this.pickUpDateTime).format('YYYY-MM-DD'))) {

        this.pickUpDateTime = newValue;

      } else {
        const today = dayjs(newValue);//new Date
        // tommorrow
        const date2 = today.add(24, 'hour');

        this.pickUpDateTime = newValue;

        this.updateReturnDateTime(date2.toDate());

      }


    },

    updateReturnDateTime(newValue) {

      this.returnDateTime = newValue;
      this.selectReturnDateTime = true;
      //console.log("ReturnDate updated to:" + moment(this.returnDateTime).format("MM/DD/YYYY, HH:mm"));
      //console.log("ReturnDate updated! ", newValue.toDate());
    },

    updateGroupedCategory(newValue) {
      console.log("updateGroupedCategory ", newValue);

      if (this.selectedGroupedCategory.includes(newValue)) {
        this.selectedGroupedCategory.splice(this.selectedGroupedCategory.indexOf(newValue), 1);
      } else {
        this.selectedGroupedCategory.push(newValue);
      }
      /*
                  try{
                      this.selectedGroupedCategory = this.groupedCategory.find((item)=> item.id===newValue).categories;
                  }catch (err) {
                      console.error(err);
                      this.selectedGroupedCategory = [];
                  }
                  */
      console.log("BOOK - updateGroupedCategory", this.selectedGroupedCategory);
    },

    filterLocations: function (filter) {
      var picker = this.$refs.locationPicker;
      if (picker) {
        picker.filterLocations(filter);
      }
    },
    selectLocation: function (id) {
      var picker = this.$refs.locationPicker;
      if (picker) {
        picker.select(id);
      }
    },
    beginSelectPickUpLocation() {
      this.filterLocations(this.pickUpLocationText);
      this.selectLocation(this.pickUpLocation);
    },
    filterPickUpLocations() {
    },
    beginSelectReturnLocation() {
    },
    filterReturnLocations() {
    },
    beginSelectPickUpDateTime() {
    },
    beginSelectReturnDateTime() {
    },

    async fetchQuotes() {
      this.quote.data.items = [];
      this.selectedItem = null;
      let params = {};
      params.pickUpLocation = this.pickUpLocationId;
      if (this.oneway) params.returnLocation = this.returnLocation;
      else params.returnLocation = this.returnLocationId;
      params.pickUpDateTime = this.pickUpDateTime;
      params.returnDateTime = this.returnDateTime;
      params.driverAge = 30;

      let tmpSelctedCategories = [];
      for (let groupedCategoryId of this.selectedGroupedCategory) {
        tmpSelctedCategories = tmpSelctedCategories.concat(this.groupedCategory.find((item) => item.id === groupedCategoryId).categories);
      }
      console.log("tmpSelctedCategories ", tmpSelctedCategories);
      params.selectedCategories = tmpSelctedCategories;

      sessionStorage.setItem('Book_page_state', JSON.stringify(params));

      this.quoteSearchInProgress = true;
      this.$router.push({
        name: "Quotes",
        params: {params: params},
      });
    },

    showModalError(msg) {
      //console.log(msg);
      return this.$bvModal
          .msgBoxOk(msg, {
            title: this.$t('message.error'),
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            headerClass: "p-2 rounded-0",
            footerClass: "p-2 rounded-0",
            centered: true,
            contentClass: 'rounded-0',
            headerClass: 'modal-header-black rounded-0',
          })
          .catch((err) => {
            console.error(err);
          });
    },

    help() {
      var ok = false;
      console.log("pickUpLocation: %d, returnLocation: %d, oneway: %d", this.pickUpLocationId, this.returnLocation, this.oneway);
      if (this.pickUpLocationId > 0)
        if (this.returnLocationId > 0)
          if (this.returnDateTime > this.pickUpDateTime)
            ok = true;
          else
            this.showModalError(this.$t('message.pickUpDateLaterThanReturnDate'));
        else
          this.showModalError(this.$t('message.noSelectedReturnLocation'));
      else
        this.showModalError(this.$t('message.noSelectedPickupLocation'));
    }

  },
  computed: {
    ...mapGetters(["locations", "insurances", "quote", "postBookingResult"]),
    // check if desktop
    desktopVersion(){
      if(this.windowWidth > 1024){
        return true;
      }else{
        return false;
      }
    },

    // check if tablet
    tabletVersion(){
      if(this.windowWidth > 700 && this.windowWidth <= 1024){
        return true;
      }else{
        return false;
      }
    },

    // check if mobile
    mobileVersion(){
      if(this.windowWidth <= 700){
        return true;
      }else{
        return false;
      }
    },
    pickUpLocationsFiltered() {
      if (this.returnLocationId !== 0) {
        return this.locations.filter((x) => x.id !== this.returnLocationId)
      } else {
        return this.locations;
      }
    },
    returnLocationsFiltered() {
      if (this.pickUpLocationId !== 0) {
        return this.locations.filter((x) => x.id !== this.pickUpLocationId)
      } else {
        return this.locations;
      }
    },


    showQuotes: {
      get() {
        return this.quote.data.items.length > 0 && this.selectedItem == null && this.showCarsDialog;
      },
      set() {
        this.selectedItem = null;
        this.showCarsDialog = false;
      },
    },
    showSelectedItem: {
      get() {
        return this.quote.data.items.length > 0 && this.selectedItem != null;
      },
      set() {
        this.unselectItem();
        this.showCarsDialog = true;
      },
    },
    canFetchQuotes() {
      //console.log("pickUpLocation: %d, returnLocation: %d, oneway: %d", this.pickUpLocationId, this.returnLocation, this.oneway);
      var ok = this.pickUpLocationId > 0 && (!this.oneway || this.returnLocation > 0);
      ok = ok && this.returnDateTime > this.pickUpDateTime;
      //console.log("canFetchQuotes: ", ok);
      return ok;
    },

    gridStyle() {
      return {
        gridTemplateColumns: `repeat(3, minmax(100px, 1fr))`
      }
    },


  },
  components: {
    DateTimeInput,
    LocationControl,
    LocationDetails,
    LocationMap,
    LocationList,
    LocationControl,
    GroupedCategoryControl,
    DateTimeInputSeparated,
    LocationControlVersion2,
  },
};
</script>

<style lang="scss" scoped>
.input-button-bislet {

  background-color: #f2f2f2;
  color:var(--agile-purple);
  font-size: 19px;

  font-family: inherit;
  font-weight: inherit;
  line-height: inherit;
  min-height: 65px;

  align-self: center;
  padding: 15px 15px;

  border: none;
  border-radius: 0.6rem;
  @media screen and (max-width: 634px) {
    font-size: 15px;
  }
}

.input-button-bislet:active, .input-button-bislet:hover {
  background: var(--agile-button-color) !important;
  color: var(--white) !important;
}

.buttons-wrapper {
  background-color: var(--agile-button-color);
  padding-bottom: 30px;
}

.buttons-inner-wrapper {
  background-color: white;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 15px;
  padding: 10px;
  border-radius: 10px;

  width: fit-content;
  margin: auto;
  justify-content: center;

}

.inputmask {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  gap: 35px;

}
.buttons-contrainer-wrapper{
  width: 100%;
  padding-bottom: 20px;
}
.category-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

width:fit-content;
background-color: white;
padding:0px 7px 7px 7px;
  border-radius: 10px;
  margin: auto;
  justify-content: center;
  gap: 0.5rem;

  .input-button {

    /* Body/Regular */
    background-color: white;
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
    line-height: inherit;
    min-height: 57px;


    align-self: center;
    padding: 15px 15px;

    color: var(--agile-purple);

    border: 1px solid var(--agile-button-color) !important;

    border: none;
    border-radius: 0.6rem;
  }

  .input-button:active, .input-button:hover {
    background: var(--agile-button-color) !important;
    color: var(--white) !important;
  }

  .activeButton {
    background: var(--agile-button-color) !important;
    color: var(--white) !important;
  }
}

.mulitple-inputs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 35px;

  .mulitple-inputs-location {
    /*    height: 36px;*/
    width: 300px;
    border-radius: 10px;
    background-color: var(--agile-custom9);
  }

  .mulitple-inputs-datetime {
    /*    height: 36px;*/
    width: 300px;
    border-radius: 10px;
    background-color: var(--agile-custom9);
  }

}
.mobile-version-multiple-inputs{
      gap:12px;
  margin-bottom: 23px;
}

.form-group {
  width: 650px;
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 768px) {
  .form-group {
    width: 300px;
  }
}

.option-footer-button {
  width: 100%;
  height: 52px;
  border-radius: 10px;
  margin-top: 13px;
  background-color: var(--agile-custom05);
  border: none;

  /* width: 100%;
   height: 58px;
   background-color: #f5501e;
   color: white;
   border-radius: 0.6rem;
   border: none;

   text-align: center;
   !* Text/Text 16 *!
   font-family: Helvetica Neue;
   font-family: Neue Helvetica,sans-serif;
   font-size: 1rem;
   font-weight: 600;
   line-height: 1em;*/
}

.option-footer-button:disabled {
  color: var(--agile-custom3);
}
</style>
